export default "__VITE_ASSET__MGa1cEfK__"